import { styled } from '@this/constants/themes';

export const Box = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  border: 2px solid ${props => props.theme.grayBorderColor};
  background: white;
  margin-bottom: 10px;
  font-size: 10px;

  ${props =>
    props.selected &&
    `
    border-color: ${props.theme.linkColor}
  `};
`;

export const BoxButtonText = styled.p`
  margin: 0 auto;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
`;

export const Yen = styled.span`
  font-size: 12px;
  margin-left: 3px;
`;
